const productsBrowserFacetSlider = () => ({
  inputLow: 0,
  inputHigh: 0,

  get normalizedValueFromSlider() {
    if (this.inputLow === this.originalRange[0] && this.inputHigh === this.originalRange[1]) {
      return '';
    }

    return `${JSON.stringify({
      min: String(this.inputLow),
      max: String(this.inputHigh),
    })}`;
  },

  get normalizedValueActive() {
    return this.$refs.activeFacetModel._x_model.get();
  },

  get range() {
    const { price } = JSON.parse(this.facet.values[0].input);

    return [price.min, price.max];
  },

  init() {
    this.setValues();
    this.originalRange = this.range;
    this.normalizedStep = 1;

    this.$nextTick(() => {
      this.$watch('normalizedValueActive', (value) => {
        value = Array.isArray(value) ? value[0] : value;
        if (value) {
          const { min, max } = JSON.parse(value);
          this.inputLow = Math.min(Math.max(Number(min), this.originalRange[0]), this.originalRange[1]);
          this.inputHigh = Math.max(Math.min(Number(max), this.originalRange[1]), this.originalRange[0]);
        } else {
          this.inputLow = this.originalRange[0];
          this.inputHigh = this.originalRange[1];
        }
      });
    });

    this.$watch('normalizedValueFromSlider', (value) => {
      this.$refs.activeFacetModel._x_model.set([value]);
    });
  },

  setValues() {
    this.inputLow = this.range[0];
    this.inputHigh = this.range[1];
  },
});

export default productsBrowserFacetSlider;
